   

    <div class="product-information-container" fxLayout="column" fxLayoutAlign="space-around stretch" fxLayoutGap="30px">
        <mat-card class="product-overview-card" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="start start">
            <div fxFlex="52.5">
                <p><strong>{{'brand' | translate}}: </strong> {{asset.brand}}</p>
                <p><strong>{{'model' | translate}}: </strong> {{asset.model}}</p>
                <p><strong>{{'serialNumber' | translate}}: </strong> {{asset.serialNumber}}</p>
                <p><strong>{{'imeiNumber' | translate}}: </strong> {{asset.imei}}</p>
            </div>
            <div>
                <p *ngIf="asset.deliveryDate"><strong>{{'deliveryDate' | translate}}: </strong> {{asset.deliveryDate | dateFormat: "L"}}</p>
                <p *ngIf="asset.warrantyEndDate"><strong>{{'warrantyEndDate' | translate}}: </strong> {{asset.warrantyEndDate | dateFormat: "L"}}</p>
            </div>
        </mat-card>
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between start">
            
            <div *ngIf="asset.assetServices.length >= 1" fxLayout="column"  fxLayoutAlign="space-between stretch" fxFlex="47.5" fxFlex.lt-md="100"  >
                <p><strong>{{'relatedServices' | translate}}</strong></p>
                <mat-card fxFlex="100" *ngFor="let service of asset.assetServices; let i = index" class="product-overview-card">
                        
                        <p *ngIf="this.selectedLanguage === 'en'"> {{service.description}}</p>
                        <p *ngIf="this.selectedLanguage === 'fr'"> {{service.description_FR}}</p>
                        <p *ngIf="this.selectedLanguage === 'nl'"> {{service.description_NL}}</p>
                        <div fxLayout = "row" fxLayoutAlign="space-between center" >   
                            <p *ngIf="service.serviceEndDate">{{'endDate' | translate}}: {{service.serviceEndDate | dateFormat: "L"}}</p>
                            <p style="color: grey;">{{service.sourceId}}</p>    
                        </div>

                </mat-card>        
            </div>
        
            <div class="warranty-information" fxLayout="column"  fxLayoutAlign="space-between stretch" fxFlex="47.5" fxFlex.lt-md="100" >
                <p><strong>{{'warrantyInfo p1' | translate}}</strong></p>
                <mat-card class="product-overview-card">
                    
                    <p>{{'warrantyInfo p2' | translate}}</p>
                    <p>{{'warrantyInfo p3' | translate}}</p>
                    <p>{{'warrantyInfo p4' | translate}}</p>
                    
                    
            
                    <a class="link" href="https://www.econocom.be/fr/GTC-BE-2021" target="_blank">{{'terms&conditions' | translate}}</a>
                </mat-card>
            </div></div>
        <div fxLayout="column" fxLayoutAlign="space-around center">
        <p><strong>{{'poDeviceIs' | translate}}:</strong></p>
        <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="20px" class="p-1">
            <button  mat-raised-button color="primary" (click)="onSubmit('broken')">{{'poOption1' | translate}}</button>
            <button  mat-raised-button color="primary" (click)="onSubmit('stolen')">{{'poOption2' | translate}}</button>
        </div>
        </div>
    
    </div>
    